import {useSalesMarketingApi} from "./useSalesMarketingApi";
import qs from "qs";
import {useContext} from "react";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";
import { CouponFiltersCampaignCodes, CouponInputByCampaignGetAll, CouponInputGetAll, RootCouponGelAll, RootCouponGetAllByCampaign } from "../page/coupon/interfaces/CouponInterfaces";

export const useCouponActions = () => {
    const {GET, POST, PUT} = useSalesMarketingApi();
    const {globalData} = useContext(GlobalContext);

    async function getCouponCampaignList(filters: CouponInputGetAll) {
        let params = {
            tenantId : filters.tenantId ? filters.tenantId : undefined,
            dealerId : filters.dealerId? filters.dealerId : undefined,
            productCode: filters.productCode ? filters.productCode : undefined,
            description: filters.description ? filters.description : undefined,
            couponCode: filters.couponCode ? filters.couponCode : undefined,
            status: filters.status ? filters.status : undefined,
            search: filters.search ? filters.search : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined
        };
        let data:RootCouponGelAll = await GET("sm/couponplan", false, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return {
            totalElements: data?.result?.totalElements,
            content: data?.result?.content
        };
    }

    async function getCouponCampaignById(id: any) {
        let data = await GET("sm/couponplan/" + id, true);
        return data?.result;
    }

    async function createCouponCampaign(payload: any, ancillaries: any[]) {
        payload.ancillaryList = ancillaries;
        return await POST("sm/couponplan", payload, true)
    }

    async function updateCouponCampaign(payload: any, ancillaries: any[]) {
        if(!payload.tenantId || payload.tenantId ==='')
            payload.tenantId = globalData?.user?.legalEntities[0]?.name;

        if(!payload.dealerId || payload.dealerId ==='')
            payload.dealerId = globalData?.user?.dealers[0]?.name;
        payload.ancillaryList = ancillaries;
        return await PUT("sm/couponplan", payload, true)
    }

    async function getCouponList(filters: CouponInputByCampaignGetAll) {
        let params = {
            tenantId : filters.tenantId ? filters.tenantId : undefined,
            dealerId : filters.dealerId? filters.dealerId : undefined,
            id: filters.id ? filters.id : undefined,
            status: filters.status ? filters.status : undefined,
            search: filters.search ? filters.search : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined
        };
        let data:RootCouponGetAllByCampaign = await GET("sm/coupon/ext", false, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return {
            totalElements: data?.page?.result?.totalElements,
            content: data?.page?.result?.content,
            countByStatus: data?.count?.result
        };
    }

    async function makeCoupons(couponCampaignId: any, quantityOfCodes: any) {
        let params = {
            howmany: quantityOfCodes
        }

        let data = await GET("sm/coupon/" + couponCampaignId +"/makecoupon", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return data?.result;
    }

    async function updateCoupon(payload: any) {
        return await PUT("sm/coupon", payload, true)
    }

    async function exportCouponList(filters:CouponFiltersCampaignCodes){
        let params = {
            tenantId: filters.tenantId ? filters.tenantId : undefined,
            dealerId: filters.dealerId ? filters.dealerId : undefined,
            status: filters.status ? filters.status : undefined,
            id: filters.id ? filters.id : undefined
        };
        return await GET(`sm/coupon/get-all-to-excel-b64`,false,{
            params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        })
    }
    async function getAllCouponCodes(search ?: string){
        let params = {
            search: search ? search : '',
            offset: 0,
            limit: 10,
        };
        let data:any = await GET("sm/coupon", false, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return  data?.result?.content.map((data:any)=> data.couponCode);
    }


    return {
        getCouponCampaignList,
        getCouponCampaignById,
        createCouponCampaign,
        updateCouponCampaign,
        getCouponList,
        makeCoupons,
        updateCoupon,
        exportCouponList,
        getAllCouponCodes
    };
}